export const frontmatter = {
    "draft": true,
    "title": "Webhooks",
    "description": "Configuración y uso de webhooks en OnnIA.",
    "sidebar_label": "Webhooks",
    "sidebar_group": "referencia",
    "sidebar_order": 3
}

export const toc = []